import { useEffect } from "react";
import { getApiUrl, triggerSignInRedirect } from "../api/client.js";

/**
 * Rendered when the API responded 401 / an oauth2-proxy opaque redirect
 * was observed. By the time this mounts, `triggerSignInRedirect()` has
 * usually already fired from the fetch layer (api/client.ts) — this
 * effect is a safety net for any path that reaches "unauthenticated"
 * without going through get()/put() (e.g. a future direct navigation
 * here). The latch in client.ts makes re-calling it a no-op.
 */
export function SignIn() {
  useEffect(() => {
    triggerSignInRedirect();
  }, []);

  function handleSignIn() {
    const apiUrl = getApiUrl();
    window.location.assign(
      `${apiUrl}/oauth2/sign_in?rd=${encodeURIComponent(window.location.href)}`,
    );
  }

  return (
    <div className="setup-screen">
      <div style={{ width: "100%", maxWidth: 360, textAlign: "center" }}>
        <div className="setup-logo">A</div>
        <h1 className="setup-title">Alkio</h1>
        <p className="setup-subtitle">Session expired — redirecting to sign-in…</p>
        <div className="setup-form">
          <button className="setup-btn" onClick={handleSignIn}>
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
  );
}
